module.exports = __webpack_public_path__ + "static/media/location_not_found.8adf8159.jpg";